import { createAction, props } from '@ngrx/store';

const GET_ALL_MODULES = '[Modules] Get All Modules';
const SET_MODULES = '[Modules] Set Modules';
const CREATE_MODULE = '[Modules] Create Module';
const UPDATE_MODULE = '[Modules] Update Module';
const DELETE_MODULE = '[Modules] Delete Module';
const SAVE_MODULE = '[Modules] Save Module';
const CREATE_MODULE_SUCCESS = '[Modules] Create Module Success';
const CREATE_MODULE_FAILURE = '[Modules] Create Module Failure';
const DELETE_MODULE_SUCCESS = '[Modules] Delete Module Success';
const UPDATE_MODULE_SUCCESS = '[Modules] Update Module Success';
const CLEAR_MODULES = '[Modules] Clear Modules';
const DELETE_MODULE_FAILURE = '[Modules] Delete Module Failure';

const getAllModules = createAction(
  GET_ALL_MODULES,
  props<{ apiConstants: any; urlPathVariables: { generationId: string }; showLoader?: boolean }>()
);
const setModules = createAction(SET_MODULES, props<{ data: any }>());
const createModule = createAction(CREATE_MODULE, props<{ apiConstants: any; data: any }>());
const createModuleSuccess = createAction(CREATE_MODULE_SUCCESS, props<{ data: any }>());
const createModuleFailure = createAction(CREATE_MODULE_FAILURE, props<{ error: any }>());
const updateModule = createAction(UPDATE_MODULE, props<{ apiConstants: any; data: any }>());
const deleteModule = createAction(DELETE_MODULE, props<{ apiConstants: any; params: { moduleId: string } }>());
const saveModule = createAction(SAVE_MODULE, props<{ data: any }>());
const deleteModuleSuccess = createAction(DELETE_MODULE_SUCCESS, props<{ componentId: string }>());
const deleteModuleFailure = createAction(DELETE_MODULE_FAILURE);
const updateModuleSuccess = createAction(UPDATE_MODULE_SUCCESS, props<{ data: any }>());
const clearModules = createAction(CLEAR_MODULES);

const ModuleActions = {
  getAllModules,
  setModules,
  createModule,
  updateModule,
  deleteModule,
  saveModule,
  createModuleSuccess,
  createModuleFailure,
  deleteModuleSuccess,
  updateModuleSuccess,
  clearModules,
  deleteModuleFailure
};

export default ModuleActions;
